// Imports every gob-type module for its CreateGob self-registration side effect
// (see factory.ts). Assemblers and re-sim tests import this once.

import './scenery.ts';
import './surfacedecal.ts';
import './animgob.ts';
import './mobilehq.ts';
import './struct.ts';
import './structtypes.ts';
import './hq.ts';
import './miner.ts';
import './processor.ts';
import './research.ts';
import './shots.ts';
import './tank.ts';
import './tower.ts';
import './infantry.ts';
import './specials.ts';
import './replicator.ts';
import './overmind.ts';
import './vts.ts';
